<template>
  <div class="my-pooq-content-body">
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
        <my-pooq-empty-list v-if="!isLoading && programLikeList.length === 0" info-text="구독한 프로그램 내역이 없어요."></my-pooq-empty-list>
        <zzim-like-info v-if="!isLoading &&programLikeList.length === 0" type="program"
                        :toggleSubScribe="toggleSubScribe"
                        :goPlayer="goPlayer">
        </zzim-like-info>
      <ul class="like-list">
        <!-- 좋아요 채널 리스트 -->
        <li v-for="(likeItem, index) in this.programLikeList" :key="likeItem.title + '_' + index">
          <a href="" class="thum-img like-program" @click.prevent="()=>goPlayer(likeItem)">
            <img v-lazy="getLazyLoadObj(likeItem)" :alt="likeItem.programtitle">
            <age-tag :age-code="likeItem.targetage" content-type="mypooq_vod" class="tag-age"></age-tag>
          </a>
          <a href="" class="like-title-link" @click.prevent="()=>goPlayer(likeItem)">
            <span class="txt-title" v-html="likeItem.programtitle"></span>
            <span class="txt-program">{{likeItem.channelname}}</span>
          </a>
          <button type="button" class="btn-like" @click.prevent="()=>toggleSubScribe(likeItem)">
            <UnSubscribeButton v-if="likeItem.zzim === 'y'"/>
            <SubscribeButton v-else/>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { MyPooqService, VodInfoService } from '@/common/api/api.service'
import { infiniteScroll } from '@/common/directives'
import SubscribeButton from '@/assets/svg/common/ic_detail_plus_off.svg'
import UnSubscribeButton from '@/assets/svg/common/ic_detail_plus_on.svg'
import { MSG_COMPLETE_ADD_ZZIM_PROGRAM, MSG_COMPLETE_DELETE_ZZIM_PROGRAM } from '@/common/constant'
import ZzimLikeInfo from '@/components/lnb/mypooq/ZzimLikeInfo'
import AgeTag from '@/components/tags/AgeTag'
import utils from '@/common/util/utils'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'MyPooqLikeProgram',
  components: {
    SubscribeButton,
    UnSubscribeButton,
    MyPooqEmptyList: () => import('@/components/lnb/mypooq/MyPooqEmptyList'),
    ZzimLikeInfo,
    AgeTag
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      programLikeList: [],
      offset: 0,
      limit: 10,
      endOfList: false,
      showEmptyList: false,
      isLoading: false,
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    goPlayer (programItem) {
      if (this.device === 'mobile') {
        VodInfoService.getContentIdByProgramId({ programID: programItem.programid }).then(({ data }) => {
          this.$router.push({
            name: 'player',
            params: {
              section: 'vod'
            },
            query: { contentid: data.contentid, referer: this.$route.fullPath }
          })
        })
      } else {
        location.href = 'captvpooq://player/vod?programid=' + programItem.programid
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.zzim({
        offset: this.offset,
        limit: this.limit,
        contenttype: 'program'
      }).then(({ data }) => {
        const resList = get(data, ['0', 'list'], [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.programLikeList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.programLikeList = this.programLikeList.concat(resList)
        this.isLoading = false
      })
    },
    toggleSubScribe (likeItem) {
      if (likeItem.zzim === 'y') {
        MyPooqService.deleteZzim({
          contenttype: 'program',
          contentids: [likeItem.programid],
          delalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_DELETE_ZZIM_PROGRAM })
          this.$nextTick(() => {
            likeItem.zzim = 'n'
          })
        })
      } else {
        MyPooqService.setZzim({
          contenttype: 'program',
          contentid: likeItem.programid,
          addalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_ADD_ZZIM_PROGRAM })
          this.$nextTick(() => {
            likeItem.zzim = 'y'
          })
        })
      }
    },
    getLazyLoadObj (likeItem) {
      return {
        src: resizeThumbnail(likeItem.image, { width: 312, height: 176, quality: 75, multiply: 3 }),
        error: '/img/common/img_default_thum_1.png',
        loading: '/img/common/img_default_thum_1.png'
      }
    }
  }
}
</script>

<style scoped>
  .mypooq-list {
    position: relative;
    width: 100%;
    height: auto;
  }
  .like-program img {
    width: 84px;
    height: 119px;
  }
  .btn-like{
    margin: auto;
  }
  .like-program{
    position: relative;
  }
  .tag-age{
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
